// import AppConfig  from '../services/app.config';
import { Modal, Button, notification } from "antd";
import React from "react";
const { confirm } = Modal;
class Notification {
  constructor() {}
  error(data) {
    let {
      message,
      btn,
      key,
      description = "ไม่สามารถเชื่อมต่อระบบได้",
      placement = "",
      duration,
      title,
    } = data;

    if (
      description === "Unauthorized : Failed to authenticate token." ||
      description === "Unauthorized"
    ) {
      return;
    }

    let okText = data.okText || "ปิด";
    let op = {};
    if (data.icon) {
      op.icon = data.icon;
    } else {
      op.icon = (
        <img
          style={{ margin: "auto", width: "55px", marginBottom: "20px" }}
          src="data:image/png;base64,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"
        />
      );
    }
    Modal.error({
      ...op,
      title: title,
      content: description,
      okText: okText,
      centered: true,
      okButtonProps: {},
      onOk() {
        if (data.onCancel) {
          data.onCancel();
        }
      },
      onCancel() {
        if (data.onCancel) {
          data.onCancel();
        }
      },
    });
    return;
  }

  success(data) {
    let {
      title,
      btn,
      key,
      description = "ไม่สามารถเชื่อมต่อระบบได้",
      placement = "",
      duration,
    } = data;
    let op = {};
    if (data.icon) {
      op.icon = data.icon;
    } else {
      op.icon = (
        <img
          style={{ margin: "auto", width: "55px", marginBottom: "20px" }}
          src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEwAAABMCAYAAADHl1ErAAAACXBIWXMAACxLAAAsSwGlPZapAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAXhSURBVHgB7ZxdchtFEIC7Z1UOVVSBcgP5AETSCbBPgH2CxO8UluKEKp4iP1FFSCwB74gTxDlBzAkkwwFYToB44CGgnaF7VqvI0upnZme1s5K/qjiSLHm9n3tmZ3qmF6EAOoNW9WMYNwRgA1DUQUAVFTQm367NvX1E/0JAGCmAIUTyTwlq+A9Uhp1mdwRbBmFLvBx8eSSC4As6YAMUHIEbhgrhRkbR2+fNn25gC+Qq7NtBq/ZRRT5WElv0tAr5ErK8fyO8/KbZDSEnchHG0RQEwQuHkWQEibumqOvlEXVOhRUtagGKuPcRnrmMOCfCuBP/NFAvlIIWeAhFXN9VU80s7PtB60QI9TPk30dlJVRSXl40f+xDBqyF+R5Vy6Bo6wqKtrblkMRKGF/9Hgj1DhbHTGUhfC/x2KaJCjDku0GrUXJZjP6D87mAIUYRxgeoxLJ87682ZTSmSPu62R1u+oGNhe2grAQjaRsJ22FZCRtLW9uHcQdPst7A7spiqnyOfK7r3rgywnjo8IlQAyh3B29CiBKbq4YcKyOMx1mwP7KYmozPeSlLI+zVoPUE4xH83iERT5896l6nfS9V2A4MTLMyoqZ5mNY0U5vkwf41xXmqy5rmQoRNousPuIey4Xj8vNm9mX1tIcIe4H72W2kEKVF2RxgnACnmjuCeGEqEvhy0jmZfuiOMFinOYafAnpR4SnmwNsSrT8bMR9m0D9u1vosWXs4umt1+8jzL9I5SQYdJKmgaYQdrBmxlYl4Ww/NEni+CRaQdCPkkeTwVhr4sXGQkTVaCrTQEnHZVWpju7Hdg3LVKVoKltGrS+WthAYgTKDmbyErQaRypfgEDAiG1o7hJCvwcSoyJrOlnTPsyxLr+74pSOEqov6Ck2MiyTVvR/PKhGMPYeCHAFzLIskosjAEaQm85KiEZZVmds4CoIeiSWYOSUYQsRqCoi6QzKwtFydLHVuohCXO0uKHgRkl1CbxbMCeKlKURWK+AgwGrAry8aHQ7k6cdSm93KL3tdKpVuKwJPA7LFGFaVn0qS0Mn1qETvARH+CKLqBnvrZglTVaCK2keydJYC1slKyGrNN9kMXbCpHq7TlaCrTQfZTEsLARD9H55A0yl+SqLGFlFGAbmk/VNpXksiwmFQrNo0VCy8er3r4yHDeukeS6LM4kjgZH6Gyygk+u4lOa9LEapW6FAmUdY8nlH0kohC/j3VKGQEFgLi39INmllkcWwK2cJRJoKddqf/eBsdL+MomQxOoGod6jQxBkyYhtpJhQpixiyq3hYQZ0ZOCBPaQXLItSv/FULi0BcgyPykFa8LN7JEzuabhV4fXvO/Zizjb+u+jQfZBHh03rvkB9MR/p0yeyBQ1xEmieyeFfATfJYfHgg+uCYLNJ8kaVRH8aMU2Ft3p3i4Gq5cCwLaV7JosxMe6aI687kO1KYyzjKRJpXskBfELuzzxf2uL4enr/LaxfiuguBb7K4BPrpo97x7EsL6Z28ooxZFWneySIwwrP51xaE6V3Djq+Ys6RJ81KWgn47pQC1kvpmEB3KYjyGnAqyWNqr385rUfRfj45VDYS6Ao9kAWehl7S0paUzk+L3N7CHKCnPlhXTL01RP2t2r/Nsmv6CvVV3HliZ0+emCTku/XtIiBI6q96wUhinMzDeDxrC7sO1ksfrbs+wdtWIrxRjiadgWRhQEjgwTtsb3Jbhvkg+lsWR5a5IPmEXb8NgIosxWsid2eMeQvkJTWUxRhGWQAsnNVXyW8lMZIVgiNVWAT4QV9+Xc5yGvcmdA0KwIPPtsCbF9GUoeR5JWgPVA/IMZNpQx/AirB6rGZaibBcdVYdZZemfBA7RfRuXQPtS1UsZZE5XzddtZ8GpsASu/BKozhHhBIogB1EJuQhL0BEHsjMp/qpBvowobdSjPqbfbpbstqRpcNQFIE8ASR46yn3xog2t2vNCdB7RlMbWhM3CG2B0oRNEDV26E1ejVOm3qcHiLCLkL0rpjX8jSlbd8i6aymSvA2yZ/wFrT2xbn198tAAAAABJRU5ErkJggg=="
        />
      );
    }

    Modal.success({
      ...op,
      okText: "ปิด",
      centered: true,
      title: title,
      content: description,
      okButtonProps: {},
      onOk(close) {
        if (data.onCancel) {
          data.onCancel();
        }
        close();
      },
      onCancel(e) {
        console.log("OonCancel...", e);
        if (data.onCancel) {
          data.onCancel();
        }
      },
    });
    return;
  }

  confirm(data) {
    let {
      message,
      key,
      okText,
      cancelText,
      icon,
      description = "ไม่สามารถเชื่อมต่อระบบได้",
      placement = "",
      duration,
    } = data;
    Modal.confirm({
      message: message,
      title: <div dangerouslySetInnerHTML={{ __html: description }}></div>,
      icon: icon,
      okText: okText,
      cancelText: cancelText,
      centered: true,
      okButtonProps: {},
      onOk(e) {
        console.log("OK...", e);
        if (data.onOk) {
          data.onOk();
        }
      },
      onCancel(e) {
        console.log("OK...", e);
        if (data.onCancel) {
          data.onCancel();
        }
      },
    });
    return;
  }
  confirmShift(data) {
    let {
      message,
      key,
      okText,
      cancelText,
      icon,
      description = "ไม่สามารถเชื่อมต่อระบบได้",
      placement = "",
      duration,
    } = data;
    Modal.confirm({
      message: 'คุณแน่ใจหรือไม่',
      title: '<div dangerouslySetInnerHTML={{ __html: description }}></div>',
      icon: 'icon',
      okText: okText,
      cancelText: cancelText,
      centered: true,
      okButtonProps: {},
      onOk(e) {
        console.log("OK...", e);
        if (data.onOk) {
          data.onOk();
        }
      },
      onCancel(e) {
        console.log("OK...", e);
        if (data.onCancel) {
          data.onCancel();
        }
      },
    });
    return;
  }
}

export default new Notification();
